function popupLink ({elementId}) {
  const popup = document.getElementById(elementId);
  const eleHtml = document.querySelector('html');
  if(popup && eleHtml){
    popup.classList.add('active');
    eleHtml.style.overflowY = 'hidden';
  }
}

export default popupLink;
